function openMessenger (options?: unknown, success?: () => void, failure?: () => void) {

	window?.Genesys('command', 'Messenger.open', options, success, failure);

}

export default openMessenger;
